import { render, staticRenderFns } from "./AppDescription.vue?vue&type=template&id=0cb4993e&scoped=true&"
import script from "./AppDescription.vue?vue&type=script&lang=js&"
export * from "./AppDescription.vue?vue&type=script&lang=js&"
import style0 from "./AppDescription.vue?vue&type=style&index=0&id=0cb4993e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4993e",
  null
  
)

export default component.exports